import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoint } from "../../../utils/constants/endpoint";

export const adminAuth = createApi({
  reducerPath: "adminAuth",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: endpoint.ADMIN_ACCOUNT.GUEST_LOGIN,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        responseHandler: (response) => response.text(),
        body: data,
      }),
    }),
    userLogin: builder.mutation({
      query: (data) => ({
        url: endpoint.USERS.GUEST_LOGIN,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        responseHandler: (response) => response.text(),
        body: data,
      }),
    }),
    getSSO: builder.query({
      query: (code) => ({
        url: `/Login/sso/callback?code=${code}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        responseHandler: (response) => response.text(),

      }),
    }),
    assignSSO: builder.mutation({
      query: ({ token, consents }) => ({
        url: "/User/tenantagreement/assign/sso",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: consents
      }),
    }),
  }),
});

export const { useLoginMutation, useUserLoginMutation, useLazyGetSSOQuery, useGetSSOQuery, useAssignSSOMutation } = adminAuth;
